import Loadable from 'react/components/loadable';

const MergeContactError = Loadable({
  loader: () => import('react/pages/contacts/merge_contact/merge_contact_error'),
});

angular.module('gym').value('MergeContactError', MergeContactError);
